import * as React from 'react';
export interface Route {
  name?: string | null | undefined;
  path?: string | null | undefined;
}
export interface CustomRoute extends Route {
  title?: string;
}

interface RoutesContextData {
  customRoute?: CustomRoute;
  routes?: Route[];
  productRoutes?: CustomRoute[];
  customRoutes?: CustomRoute[] | null;
  addRoutes(routes: Route[]): Promise<void>;
  setCustomProductRoutes(routes: CustomRoute[]): Promise<void>;
  setCustomRoutes(routes: CustomRoute[] | null): Promise<void>;
  setInitialRoutes(routes: Route[]): Promise<void>;
  addCustomName(routeTitle: CustomRoute): Promise<void>;
}

const RoutesContext = React.createContext<RoutesContextData>(
  {} as RoutesContextData,
);

const RoutesProvider: React.FC = ({ children }) => {
  const [routes, setRoutes] = React.useState<Route[]>([]);
  const [customRoute, setCustomRoute] = React.useState<CustomRoute>();
  const [productRoutes, setProductRoutes] = React.useState<CustomRoute[]>();
  const [customRoutes, setCrmCustomRoutes] = React.useState<
    CustomRoute[] | null
  >();

  async function addRoutes(newRoutes: Route[]) {
    setRoutes([...routes, ...newRoutes]);
  }
  async function setCustomProductRoutes(newRoutes: Route[]) {
    setProductRoutes(newRoutes);
  }
  async function setCustomRoutes(newRoutes: Route[] | null) {
    setCrmCustomRoutes(newRoutes);
  }
  async function setInitialRoutes(initialRoutes: Route[]) {
    setRoutes(initialRoutes);
  }
  async function addCustomName(routeWithTitle: CustomRoute) {
    setCustomRoute(routeWithTitle);
  }

  return (
    <RoutesContext.Provider
      value={{
        addCustomName,
        addRoutes,
        customRoute,
        productRoutes,
        routes,
        setInitialRoutes,
        setCustomProductRoutes,
        setCustomRoutes,
        customRoutes,
      }}
    >
      {children}
    </RoutesContext.Provider>
  );
};

export { RoutesProvider, RoutesContext };
